import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  patientMeetingStatus,
  updateAppoinmentStatus,
} from "../../../api/apiHandler";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import constant from "../../../constant/constant";
import Select from "react-select";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import moment from "moment-timezone";
import { Dropdown, Form } from "react-bootstrap";
import { EmailMeetingRecordsPopup } from "../../../modal/emailMeetingRecordsPopup/index.js";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import queryString from "query-string";
import CustomPagination from "../../common/Pagination/CustomPagination.js";
function MeetingStatus() {
  const navigate = useNavigate();
  const [patientMeetingStatusList, setPatientMeetingStatusList] = useState([]);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [userTimezone, setUserTimezone] = useState("");
  const [selectLang, setSelectLang] = useState({});
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [meetingId, setMeetingId] = useState("");
  const [refresh, setRefresh] = useState(false);
  const params = queryString.parse(window.location.search);
  // console.log("currentTime",moment(currentTime).format('DD/MM/YYYY hh:mm A'));
  let userRole = localStorage.getItem("user_login_type_role");
  console.log("navigateData", navigate);
  const doctorSpecialities = [
    { value: 0, label: "All" },
    //{ value: 1, label: "PENDING" },
    { value: 2, label: "ACCEPTED" },
    // { value: 3, label: "REJECTED" },
    { value: 4, label: "ONGOING" },
    { value: 5, label: "DONE" },
    { value: 6, label: "CANCELLED" },
  ];

  const [selectedStatus, setSelectedStatus] = useState(doctorSpecialities[0]);

  const selectLangFunc = async (e, id) => {
    try {
      console.log(e.target.value, id);
      let obj = { ...selectLang, [id]: e.target.value };
      console.log("testtt==>", obj);
      setSelectLang(obj);
    } catch (error) {}
  };

  useEffect(() => {
    // const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezone = moment.tz.guess();
    setUserTimezone(timezone);
    if (searchQuery == "") {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }
    patientMeetingStatus({
      page: pageNo,
      record_count: perPage,
      search_text: searchQuery,
      appointmentStatus: selectedStatus.value,
    }).then((response) => {
      Swal.close();
      response = JSON.parse(response);
      console.log("response", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        console.log("pati2123320ent_data", response.data);
        const defaultSelections = {};
        response.data.patient_data.forEach((item) => {
          defaultSelections[item.id] = item.doctor_language || "English";
        });
        setSelectLang(defaultSelections);
        setPatientMeetingStatusList(response.data.patient_data);
        setTotalRecordCount(
          Math.ceil(response.data.total_record_count / perPage)
        );
      } else {
        setPatientMeetingStatusList([]);
        setTotalRecordCount(1);
      }
      setRefresh(false);
    });

    // Swal.close();
  }, [searchQuery, pageNo, refresh, selectedStatus]);

  const handlePageClick = (event) => {
    setPageNo(event.selected + 1);
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const handleStartMeeting = (patient_data, meetType = "") => {
    const startMeetingObj = {
      name: localStorage.getItem("user_name"),
      email: localStorage.getItem("user_email"),
      appointment_id: patient_data.id,
      role: parseInt(localStorage.getItem("user_login_type_role")),
      start_meeting: 1,
      patient_id: patient_data.patient_information.id,
      language: selectLang?.[patient_data.id] || "English",
      // "language": (selectLang?.[patient_data.id] || "English")
    };
    // navigate('/meeting', { state: startMeetingObj })
    console.log("joinMeetingObj", startMeetingObj);
    if (meetType == "Gemini") {
      navigate("/meetingv2", { state: startMeetingObj });
      localStorage.setItem("meeting_room", "/meetingv2");
    } else if (meetType == "mini") {
      navigate("/meetingmini", { state: startMeetingObj });
      localStorage.setItem("meeting_room", "/meetingmini");
    } else if (meetType == "o3-mini") {
      navigate("/meetingo3mini", { state: startMeetingObj });
      localStorage.setItem("meeting_room", "/meetingo3mini");
    } else if (meetType == "trsln") {
      navigate("/meeting-trsln", { state: startMeetingObj });
      localStorage.setItem("meeting_room", "/meeting-trsln");
    } else if (meetType == "trspt") {
      navigate("/meeting-trspt", { state: startMeetingObj });
      localStorage.setItem("meeting_room", "/meeting-trspt");
    } else if (meetType == "singleMIc") {
      navigate("/meeting-single-mic", { state: startMeetingObj });
      localStorage.setItem("meeting_room", "/meeting-single-mic");
    } else {
      navigate("/meeting", { state: startMeetingObj });
      localStorage.setItem("meeting_room", "/meeting");
    }
  };
  const handleJoinMeeting = (patient_data, meetType = "") => {
    try {
      const meetingInfo = patient_data?.meeting_information?.[0];
      const patientInfo = patient_data?.patient_information;

      if (!meetingInfo || !patientInfo) {
        console.error("Missing meeting or patient information.");
        return Swal.fire({
          icon: "error",
          title: "Error",
          text: "Invalid patient or meeting data.",
        });
      }
      console.log(patient_data, "123444====>>>>");

      const joinMeetingObj = {
        meeting_id: meetingInfo.meeting_id,
        appointment_id: patient_data.id,
        user_id: localStorage.getItem("user_id"),
        name: localStorage.getItem("user_name"),
        email: localStorage.getItem("user_email"),
        role: parseInt(localStorage.getItem("user_role")),
        start_meeting: 0,
        patient_id: patientInfo.id,
        language: selectLang?.[patient_data.id] || "English",
        meetType: meetType,
      };

      console.log("joinMeetingObj", joinMeetingObj);
      //  meetType == "Gemini"
      //           ? "/meetingv2"
      //           :
      const route = meetType === "trsln" ? "/meeting-trsln" : "/meeting";

      navigate(route, { state: joinMeetingObj });
      localStorage.setItem("meeting_room", route);
    } catch (error) {
      console.error("handleJoinMeeting Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while joining the meeting.",
      });
    }
  };

  const handleAutoRx = async () => {
    try {
      if (userRole == "4") {
        navigate("/priest/carepoint/1");
      } else if (params?.isPriestMeeting == "true") {
        navigate("/patient/carepoint/1");
      } else {
        navigate("/doctor/carepoint/1");
      }
    } catch (error) {}
  };

  const isOpenMailModal = (meetingId) => {
    setIsOpen(true);
    setMeetingId(meetingId);
  };

  const handleMeetiRecord = async (id) => {
    try {
      console.log("item.meeting_information[0].meeting_id,", id);
      if (userRole == "4") {
        navigate(`/priest/meeting-record/${id}`);
      } else if (params?.isPriestMeeting == "true") {
        navigate(`/patient/meeting-record/${id}`);
      } else {
        navigate(`/doctor/meeting-record/${id}`);
      }
    } catch (error) {}
  };

  const handleMeetingStatus = (id) => {
    const updateStatusObj = {
      appointment_id: id,
      appointment_status: process.env.REACT_APP_MEETING_DONE,
    };

    updateAppoinmentStatus(updateStatusObj).then(async (response) => {
      response = JSON.parse(response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        SpeechRecognition.stopListening();
        setRefresh(true);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };

  return (
    <>
      <Header />
      <EmailMeetingRecordsPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        meetingId={meetingId}
        setMeetingId={setMeetingId}
      />
      <section className="doctorsec-pad">
        <div className="container">
          <div className="mt-4">
            <p className="font_22 font_600 mb-0">Meeting Status </p>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/doctor/home" className="font_14">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active font_14"
                  aria-current="page"
                >
                  Meeting Status
                </li>
              </ol>
            </nav>
          </div>
          <div className="card">
            <div className="card-body doctor-table-card">
              <div
                className="row justify-content-between position-relative"
                style={{ zIndex: 99 }}
              >
                <div className="search-bar col-lg-3 col-md-3">
                  <label
                    htmlFor="statusFilter"
                    className="white-space-nw"
                    style={{ marginRight: "8px", fontSize: "14px" }}
                  >
                    Filter by Status:
                  </label>
                  <div className="w-100" style={{ maxWidth: 200 }}>
                    <Select
                      placeholder="Filter by Status"
                      className="react-select__menu"
                      classNamePrefix="select"
                      name="selectedStatus"
                      options={doctorSpecialities}
                      value={selectedStatus}
                      onChange={(selectedOption) => {
                        setSelectedStatus(selectedOption);
                        setPageNo(1);
                        setSearchQuery("");
                      }}
                    />
                  </div>
                </div>
                <div className="search-bar col-lg-3 col-md-3">
                  <label
                    htmlFor="statusFilter"
                    className="white-space-nw"
                    style={{ marginRight: "8px", fontSize: "14px" }}
                  >
                    Search by:
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Name or Email"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>
              </div>
              <div className="table-responsive">
                <div className="search-bar"></div>
                <table
                  id="mangeUser"
                  className="table table-hover dataTable js-exportable"
                >
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Patient Name</th>
                      <th>Phone Number</th>
                      <th>Email Address</th>
                      <th>Date Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {patientMeetingStatusList &&
                      patientMeetingStatusList.map((item, index) => {
                        return (
                          <tr id={item.id} key={index}>
                            <td>{item.id}</td>

                            <td>
                              <h3 className="doc-details">
                                <div className="doc-profile">
                                  <img
                                    src={item.patient_information.profile_image}
                                    alt=""
                                  />
                                </div>
                                {item.patient_information.patient_full_name}
                              </h3>
                            </td>
                            <td>
                              {item.patient_information.country_code +
                                " " +
                                item.patient_information.patient_phone_no}
                            </td>
                            <td>{item.patient_information.patient_email}</td>
                            <td>
                              {/* {moment.utc(item.appointment_date + " " + item.appointment_time).tz(userTimezone).format('DD/MM/YYYY hh:mm A')} */}
                              {moment
                                .tz(
                                  `${item.appointment_date} ${item.appointment_time}`,
                                  "YYYY-MM-DD hh:mm A",
                                  "UTC"
                                )
                                .tz(userTimezone)
                                .format("DD/MM/YYYY hh:mm A")}
                            </td>
                            <td>
                              <div
                                className="d-flex gap-2 flex-wrap align-items-center"
                                style={{ maxWidth: 300 }}
                              >
                                <button>
                                  {item.appointment_status === 1 ? (
                                    <p className="meeting-status status-pending font_600 ">
                                      Pending
                                    </p>
                                  ) : item.appointment_status === 2 ? (
                                    <p className="meeting-status status-accept font_600 ">
                                      Accepted
                                    </p>
                                  ) : item.appointment_status === 3 ? (
                                    <p className="meeting-status status-reject font_600 ">
                                      Reject
                                    </p>
                                  ) : item.appointment_status === 4 ? (
                                    <p className="meeting-status status-ongoing font_600 ">
                                      Ongoing
                                    </p>
                                  ) : item.appointment_status === 5 ? (
                                    <p className="meeting-status status-accept font_600 ">
                                      Done
                                    </p>
                                  ) : (
                                    <p className="meeting-status status-reject font_600 ">
                                      Cancelled
                                    </p>
                                  )}
                                </button>
                                {item.appointment_status === 5 ? (
                                  <>
                                    <button
                                      className="commonBtn btn-sm px-2"
                                      onClick={() => handleAutoRx()}
                                    >
                                      {" "}
                                      AutoRx
                                    </button>
                                    <button
                                      className="commonBtn btn-sm px-2"
                                      onClick={() =>
                                        handleMeetiRecord(
                                          item.meeting_information[0].meeting_id
                                        )
                                      }
                                    >
                                      {" "}
                                      Meeting Record
                                    </button>
                                    <button
                                      className="commonBtn btn-sm px-2"
                                      onClick={() =>
                                        isOpenMailModal(
                                          item.meeting_information[0].meeting_id
                                        )
                                      }
                                    >
                                      {" "}
                                      Mail Record
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    {/* {item.appointment_status === 5 ? */}
                                    {item.appointment_status !== 6 ? (
                                      item.is_schedule === 1 &&
                                      item.appointment_status === 4 ? (
                                        <>
                                          {item?.doctor_language ? (
                                            <button>
                                              <p className="meeting-status status-ongoing font_600">
                                                {item?.doctor_language}
                                              </p>
                                            </button>
                                          ) : (
                                            <Form.Select
                                              className="meeting-status status-ongoing text-white border-white font_16"
                                              aria-label="Default select example"
                                              value={
                                                selectLang?.[item.id] ||
                                                "English"
                                              }
                                              onChange={(e) =>
                                                selectLangFunc(e, item.id)
                                              }
                                            >
                                              {constant?.language.map(
                                                (lang) => (
                                                  <option
                                                    key={lang}
                                                    value={lang}
                                                  >
                                                    {lang}
                                                  </option>
                                                )
                                              )}
                                            </Form.Select>
                                          )}

                                          <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleJoinMeeting(item)
                                            }
                                          >
                                            Join GPT
                                          </button>
                                          <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleJoinMeeting(
                                                item,
                                                "gemini-2"
                                              )
                                            }
                                          >
                                            Join Gemini
                                          </button>
                                          <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleJoinMeeting(
                                                item,
                                                "gemini-3"
                                              )
                                            }
                                          >
                                            Join Gemini 3
                                          </button>
                                          <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleJoinMeeting(item, "gpt-5")
                                            }
                                          >
                                            Join GPT 5
                                          </button>
                                          <button
                                            className="meeting-status status-ongoing font_14"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleJoinMeeting(item, "trspt")
                                            }
                                          >
                                            Join GPT Lingua
                                          </button>
                                          <button
                                            className="meeting-status status-reject font_600"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleMeetingStatus(item.id)
                                            }
                                          >
                                            End
                                          </button>
                                        </>
                                      ) : (
                                        <>
                                          {item?.doctor_language ? (
                                            <button>
                                              <p className="meeting-status status-ongoing font_600">
                                                {item?.doctor_language}
                                              </p>
                                            </button>
                                          ) : (
                                            <Form.Select
                                              className="meeting-status status-ongoing text-white border-white font_16"
                                              aria-label="Default select example"
                                              value={
                                                selectLang?.[item.id] ||
                                                "English"
                                              }
                                              onChange={(e) =>
                                                selectLangFunc(e, item.id)
                                              }
                                            >
                                              {constant?.language.map(
                                                (lang) => (
                                                  <option
                                                    key={lang}
                                                    value={lang}
                                                  >
                                                    {lang}
                                                  </option>
                                                )
                                              )}
                                            </Form.Select>
                                          )}

                                          <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleStartMeeting(item)
                                            }
                                          >
                                            Start{" "}
                                            <span
                                              style={{
                                                color: "red",
                                                fontSize: "20px",
                                              }}
                                            >
                                              /
                                            </span>
                                            Join GPT
                                          </button>
                                          {/* <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleStartMeeting(item, "Gemini")
                                            }
                                          >
                                            Start{" "}
                                            <span
                                              style={{
                                                color: "red",
                                                fontSize: "20px",
                                              }}
                                            >
                                              /
                                            </span>
                                            Join Gemini
                                          </button> */}
                                          {/* <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleStartMeeting(item, "mini")
                                            }
                                          >
                                            Start{" "}
                                            <span
                                              style={{
                                                color: "red",
                                                fontSize: "20px",
                                              }}
                                            >
                                              /
                                            </span>
                                            Join o1-mini
                                          </button> */}
                                          {/* <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleStartMeeting(
                                                item,
                                                "o3-mini"
                                              )
                                            }
                                          >
                                            Start{" "}
                                            <span
                                              style={{
                                                color: "red",
                                                fontSize: "20px",
                                              }}
                                            >
                                              /
                                            </span>
                                            Join o3-mini
                                          </button> */}
                                          {/* <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleStartMeeting(item, "trsln")
                                            }
                                          >
                                            Start{" "}
                                            <span
                                              style={{
                                                color: "red",
                                                fontSize: "20px",
                                              }}
                                            >
                                              /
                                            </span>
                                            Join GPT Transl
                                          </button> */}
                                          <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleJoinMeeting(
                                                item,
                                                "gemini-2"
                                              )
                                            }
                                          >
                                            Join Gemini
                                          </button>
                                          <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleJoinMeeting(
                                                item,
                                                "gemini-3"
                                              )
                                            }
                                          >
                                            Join Gemini 3
                                          </button>
                                          <button
                                            className="meeting-status status-ongoing font_16"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleJoinMeeting(item, "gpt-5")
                                            }
                                          >
                                            Join GPT 5
                                          </button>
                                          <button
                                            className="meeting-status status-ongoing font_14"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleStartMeeting(item, "trspt")
                                            }
                                          >
                                            Start{" "}
                                            <span
                                              style={{
                                                color: "red",
                                                fontSize: "20px",
                                              }}
                                            >
                                              /
                                            </span>
                                            Join GPT Lingua
                                          </button>
                                          <button
                                            className="meeting-status status-reject font_600"
                                            style={{ whiteSpace: "nowrap" }}
                                            onClick={() =>
                                              handleMeetingStatus(item.id)
                                            }
                                          >
                                            End
                                          </button>
                                        </>
                                      )
                                    ) : null}
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel=" > "
                  onPageChange={handlePageClick}
                  pageCount={totalRecordCount}
                  previousLabel=" < "
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="page-link"
                  previousLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  disabledClassName="disabled"
                  activeClassName="active"
                  activeLinkClassName="active-link"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default MeetingStatus;
